import React from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { createStore } from "./redux/store";
import App from "./App";

const rootElement = document.getElementById("root");

const initialData = window.__INITIAL_DATA__ || [];
// Retrieve preloaded state from server
const preloadedState = window.__PRELOADED_STATE__ || {};
const { store, persistor } = createStore(preloadedState);

// const root = createRoot(rootElement);

// root.render(
//   <BrowserRouter>
//     <Provider store={store}>
//       {/* Only use PersistGate after hydration */}
//       <Toaster position="top-right" reverseOrder={false} />
//       <App />
//     </Provider>
//   </BrowserRouter>
// );

hydrateRoot(
  rootElement,
  <BrowserRouter>
    <Provider store={store}>
      {/* Only use PersistGate after hydration */}
      <App initialData={initialData} />
    </Provider>
  </BrowserRouter>
);

// Start persistor AFTER hydration to avoid SSR mismatch
persistor.persist();
